import React from 'react';
import { Theme, IconButton, Grid, Typography } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { CurrencyObject } from 'common/types';
import { RiPencilLine } from 'react-icons/ri';
import classNames from 'classnames';
import { getPricingString } from 'common/utils/common';

interface Props {
	totalPrice: number;
	currency: CurrencyObject;
	totalDeposit?: number;
	editingPrice: boolean;
	disabled: boolean;
	setEditingPrice: (editing: boolean) => void;
}

const PriceButton = (props: Props) => {
	const classes = useStyles();
	const { totalPrice, editingPrice, setEditingPrice, currency, totalDeposit, disabled } = props;

	return (
		<Grid
			container
			justifyContent="flex-start"
			className={classNames(classes.container, !editingPrice && classes.greyBg)}
		>
			<Grid item className={classNames(classes.priceContent, classes.priceAmount)}>
				<Typography component="span">{getPricingString(totalPrice, currency)}</Typography>
				{!!totalDeposit && (
					<Typography variant="caption" color="textSecondary" component="span">
						{'+'}
						{getPricingString(totalDeposit, currency)}
					</Typography>
				)}
			</Grid>
			<Grid item className={classes.priceContent}>
				{!editingPrice && (
					<IconButton
						onClick={() => setEditingPrice(!editingPrice)}
						className={classes.iconButton}
						disabled={disabled}
						size="large"
					>
						<RiPencilLine size={18} />
					</IconButton>
				)}
			</Grid>
		</Grid>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		iconButton: {
			width: theme.spacing(4),
			height: theme.spacing(4),
			padding: 0,
		},
		priceContent: {
			display: 'flex',
			alignItems: 'center',
		},
		priceAmount: {
			minWidth: '65px',
			flexDirection: 'column',
			alignSelf: 'center',
			'& span': {
				lineHeight: 1.1,
			},
		},
		container: {
			minHeight: '40px',
			padding: theme.spacing(0.5, 1, 0.5, 1),
			borderRadius: theme.spacing(0.5),
		},
		greyBg: {
			backgroundColor: theme.palette.background.secondary,
		},
	}),
);

export default PriceButton;
